import React from "react";

const services = [
  {
    title: "Make up",
    image: "/images/clientone.svg",
    link: "/services/makeup",
  },
  {
    title: "Wig Installation",
    image: "/images/clienttwo.svg",
    link: "/services/wig-installation",
  },
  {
    title: "Online Store",
    image: "/images/clientthree.svg",
    link: "/shop",
  },
] as const;

const Services: React.FC = () => {
  return (
    <section className="w-full mx-auto pb-16 bg-[#FBEFEF]">
      <div className="max-w-[1170px] mx-auto px-4">
        {/* Header */}
        <div className="flex items-center justify-center py-16 h-[40px] w-[280px] mx-auto lg:w-full">
          <img src="/images/servicesText.svg" alt="" />
        </div>

        {/* Services Grid */}
        <div className="md:grid md:grid-cols-3 gap-8 hidden">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="relative rounded-lg w-full h-[253px] overflow-hidden"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transition-transform group-hover:scale-105 transition-all"
              />
              <div
                className="absolute inset-x-0 bottom-0 bg-black/40 flex items-center justify-center h-20"
                style={{ fontFamily: "Cormorant Infant, serif" }}
              >
                <h3 className="text-2xl font-playfair text-white">
                  {service.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Horizontal Scroll for Mobile */}
        <div className="flex md:hidden gap-4 overflow-x-auto px-2">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="relative rounded-lg flex-shrink-0 w-[250px] h-[253px]"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transition-transform group-hover:scale-105 transition-all"
              />
              <div
                className="absolute inset-x-0 bottom-0 bg-black/40 flex items-center justify-center h-20"
                style={{ fontFamily: "Cormorant Infant, serif" }}
              >
                <h3 className="text-2xl font-playfair text-white">
                  {service.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
